export interface WeightRecord { id: string; date: string; weightKg: number }

const STORAGE_KEY = "yumnote.weight-history.v1";

export function readWeightHistory(): WeightRecord[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]");
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((row): row is WeightRecord => row && typeof row.id === "string" && typeof row.date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(row.date) && Number.isFinite(row.weightKg) && row.weightKg > 0).sort((a, b) => a.date.localeCompare(b.date) || a.id.localeCompare(b.id));
  } catch { return []; }
}

export function saveWeightRecord(date: string, weightKg: number, id?: string): void {
  const records = readWeightHistory();
  const record = { id: id ?? crypto.randomUUID(), date, weightKg };
  const index = records.findIndex(item => item.id === record.id);
  if (index < 0) records.push(record); else records[index] = record;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

export function deleteWeightRecord(id: string): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(readWeightHistory().filter(record => record.id !== id)));
}
